<template>
  <basic-container>
    <avue-crud
      :option="option"
      :data="data"
      ref="crud"
      v-model="form"
      :page.sync="page"
      :searchShow="true"
      :searchMenuSpan="4"
      :searchBtnText="''"
      @refresh-change="refreshChange"
      @search-change="searchChange"
      @search-reset="searchReset"
      @selection-change="selectionChange"
      @on-load="page => onLoad(page, params)"
      @row-del="deleteOnlineFollow"
      @row-update="updateOnlineFollow"
      @row-save="saveOnlineFollow"
      :header-cell-class-name="headerCellClassName"
    >
      <template slot="menuLeft"></template>
      <template slot="content" slot-scope="{ row }">
        <div style="white-space: pre-line; word-break: break-all">
          {{ row.content }}
        </div>
      </template>
      <template slot="finish" slot-scope="{ row }">
        <div style="white-space: pre-line; word-break: break-all">
          {{ row.finish }}
        </div>
      </template>
      <template slot="record" slot-scope="{ row }">
        <div style="white-space: pre-line; word-break: break-all">
          {{ row.record }}
        </div>
      </template>
      <!-- <template slot="follow" slot-scope="{ row }">
        <div style="white-space: pre-line; word-break: break-all">
          {{ row.follow }}
        </div>
      </template> -->
      <template slot-scope="scope" slot="follow">
        <el-button type="text" size="small" @click="archiveType7(scope.row)">查看详情</el-button>
      </template>
      <template slot="menu">
        <el-button type="text" size="small">数字档案</el-button>
      </template>
    </avue-crud>
    <el-dialog title="诊疗方案调整" :visible.sync="dialogVisible" width="50%" :before-close="handleClose">
      <div class="risk">
        <div v-for="item in riskContent" :key="item">
          {{ item }}
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
      </span>
    </el-dialog>
  </basic-container>
</template>

<script>
import { mapGetters } from 'vuex'
import { getOnlineFollow, saveOrUpdateOnlineFollow, deleteOnlineFollow } from '@/api/health/manage'

export default {
  data() {
    return {
      params: {
        channel: window.localStorage.getItem('channel')
      },
      form: {},
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0
      },
      selectionList: [],
      headerCellClassName: 'headerClass',
      option: {
        tip: false,
        border: true,
        index: true,
        indexLabel: '序号',
        viewBtn: true,
        editBtn: true,
        addBtn: true,
        delBtn: true,
        addBtnText: '新 增 数 据',
        selection: true,
        searchMenuSpan: 4,
        menuTitle: '操作完成确认',
        align: 'center',
        column: [
          // {
          //   label: '随访计划',
          //   prop: 'plan',
          //   search: true,
          //   type: 'select',
          //   searchSpan: 5,
          //   dicData: [
          //     { label: '新用户首次随访', value: 0 },
          //     { label: '老用户定期随访', value: 1 }
          //   ]
          // },
          {
            label: '用户姓名',
            prop: 'customer',
            width: 80,
            search: true,
            searchSpan: 5
          },
          {
            label: '性别',
            width: 60,
            prop: 'sex',
            searchSpan: 5
          },
          {
            label: '年龄',
            width: 60,
            prop: 'age',
            searchSpan: 5
          },
          {
            label: '联系方式',
            prop: 'phone',
            width: 120,
            search: true,
            searchSpan: 5
          },
          {
            label: '重大疾病风险',
            width: 150,
            prop: 'content'
          },
          // {
          //   label: ' 执行时间',
          //   prop: 'followDate',
          //   type: 'datetime',
          //   valueFormat: 'yyyy-MM-dd HH:mm:ss'
          // },
          {
            label: '慢病未达标状态',
            prop: 'finish',
            width: 140
          },
          {
            label: '健康管理措施',
            prop: 'record',
            width: 250
          },
          {
            label: ' 诊疗方案调整',
            prop: 'follow',
            align: 'center'
          },
          {
            label: '管理信息推送内容',
            prop: 'push',
            width: 320
          },
          {
            label: '线上诊前指导',
            prop: '指导',
            width: 150
          }
        ]
      },
      data: [
        {
          plan: 0,
          customer: '用户',
          sex: '男',
          age: '40',
          phone: '12345678901',
          content: '心肌梗死：低风险\n 脑卒中：高风险',
          finish: '高血压病\n2型糖尿病',
          followDate: '2025-11-3',
          record: '1、医院调整用药方案。\n2、增加健康数据检测频率。\n3、医院复查检验检查',
          finished: 1,
          follow:
            '1、药物调整方案：' +
            '\n紧急启动降糖治疗：患者空腹血糖13.11 mmol/L，糖化血红蛋白10.4%，已达糖尿病诊断标准且血糖水平显著升高。建议立即转诊至内分泌科，评估并启动强化降糖方案（可能需胰岛素起始治疗以快速控制血糖、解除高糖毒性），并制定长期口服药或联合胰岛素治疗方案。、' +
            '\n\n综合管理心脑血管风险：患者有“高血压史（治疗中）”，且血脂异常明显（总胆固醇5.59，甘油三酯2.87，LDL-C 3.54），主动脉见钙化。建议同期转诊心内科或由内分泌科协同管理，评估当前血压控制水平，启动或调整降压药物（优选兼具心肾保护的药物），并立即启动他汀类药物治疗以控制血脂、稳定斑块;' +
            '\n\n2、检查检验方案' +
            '\n近期必需检查（1周内）：' +
            '\n复查空腹及餐后2小时血糖、糖化血红蛋白，完善糖尿病自身抗体检查（鉴别分型）' +
            '\n尿常规、尿微量白蛋白/肌酐比值，启动糖尿病肾病筛查。' +
            '\n完善动态血糖监测（如条件允许），为降糖方案调整提供依据。' +
            '\n\n短期随访复查（1-3个月）：' +
            '\n复查肝功能、血脂全套，评估降脂药疗效及脂肪肝影响。' +
            '\n建议行颈动脉超声复查（尽管本次正常），评估动脉粥样硬化进展。' +
            '\n\n定期监测：' +
            '\n遵主检建议，3-6个月后复查甲状腺彩超（TI-RADS 3类结节）。' +
            '\n6-12个月复查腹部彩超（监测脂肪肝、胆囊息肉）、胸部CT（监测肺大泡）;' +
            '\n\n3、生活方式调整（需对患者进行详细宣教）：' +
            '\n运动：在血糖控制稳定（空腹血糖<10 mmol/L，无酮症）后，开始每周≥150分钟中等强度有氧运动（如快走、游泳），可分次进行，避免空腹及药物作用高峰时段运动。' +
            '\n\n营养：立即启动医学营养治疗（建议内分泌科营养师指导）。原则：控制总热量，严格低碳水化合物饮食（主食定量、粗细搭配），低脂肪（尤其减少饱和脂肪），适量优质蛋白，保证膳食纤维摄入。必须严格戒酒。' +
            '\n\n睡眠：针对“打鼾症状”，建议侧卧，减重。若家属反映有呼吸暂停或患者日间嗜睡明显，应建议其至呼吸内科/睡眠中心进行多导睡眠监测，明确是否存在阻塞性睡眠呼吸暂停低通气综合征（OSAHS），因其与血糖、血压控制不佳密切相关。' +
            '\n\n情绪与心理：问卷提示存在焦虑、抑郁情绪及情绪不稳定。应进行简短心理疏导，告知其情绪对血糖、血压的负面影响。建议通过规律运动、正念减压等方式调节。若症状持续，可建议其至临床心理科/精神卫生科就诊评估。',
          push: '您的血糖、血脂结果严重异常、高血压病、2型糖尿病未达标，脑卒中高风险，需要调整用药方案，请携带报告至泰山社区卫生服务中心内科就诊。'
        }
      ],
      dialogVisible: false,
      riskContent: ''
    }
  },
  computed: {
    ...mapGetters(['permission']),
    permissionList() {
      return {
        addBtn: this.permission.health_userjk_add,
        viewBtn: this.permission.health_userjk_view,
        delBtn: this.permission.health_userjk_delete,
        editBtn: this.permission.health_userjk_edit
      }
    },
    ids() {
      const ids = []
      this.selectionList.forEach(ele => {
        ids.push(ele.id)
      })
      return ids.join(',')
    }
  },
  methods: {
    onLoad(page, params) {
      console.log('onLoad?')
      params.channel = window.localStorage.getItem('channel')
      params.type = 2
      getOnlineFollow(page.currentPage, page.pageSize, params).then(res => {
        // this.page.total = res.data.total
        // this.data = res.data.onlineFollow
      })
    },
    archiveType7(row) {
      console.log(row)
      this.dialogVisible = true
      if (row.follow.includes(';')) {
        const result = row.follow.split(';')
        console.log(result)
        this.riskContent = result
        console.log(this.riskContent)
      }
    },
    saveOnlineFollow(row, index, done, loading) {
      console.log('save?')
      row.channel = window.localStorage.getItem('channel')
      row.type = 2
      saveOrUpdateOnlineFollow(row)
        .then(res => {
          done()
          this.$refs.crud.closeDialog() // 强制关闭弹窗
          this.onLoad(this.page, this.params)
          this.$message.success('添加成功!')
        })
        .catch(() => {
          this.onLoad(this.page, this.params)
        })
    },

    updateOnlineFollow(row, index, done, loading) {
      // row.channel = window.localStorage.getItem("channel");
      row.type = 2
      console.log(row)
      if (row.id == null) {
        done()
        this.$message.success('数据未修改!')
        return
      }
      saveOrUpdateOnlineFollow(row)
        .then(() => {
          done()
          this.onLoad(this.page, this.params)
          this.$message.success('修改成功!')
        })
        .catch(() => {
          this.onLoad(this.page, this.params)
        })
    },

    deleteOnlineFollow(row) {
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          return deleteOnlineFollow(row)
        })
        .then(() => {
          this.onLoad(this.page, this.params)
          this.$message({
            type: 'success',
            message: '操作成功!'
          })
        })
    },

    searchReset() {
      this.params = {
        channel: window.localStorage.getItem('channel')
      }
      this.onLoad(this.page, this.params)
    },

    searchChange(params, done) {
      console.log('SeachChange?')
      params.channel = window.localStorage.getItem('channel')
      this.params = params
      this.page.currentPage = 1
      this.onLoad(this.page, params)
      done()
    },

    selectionChange(list) {
      this.selectionList = list
    },

    refreshChange(data) {
      this.onLoad(this.page, data.searchForm)
    }
  }
}
</script>
<style scoped>
.headerClass {
  background-color: #409eff !important;
  color: #fff !important;
}

.el-table .el-table__cell {
  text-align: left !important;
}
.risk {
  padding: 20px;
  line-height: 30px;
}
.risk div {
  padding: 10px;
  background: #f5f5f5;
  color: #222;
  border-radius: 12px;
  margin-bottom: 16px;
}
</style>
